module.exports = __webpack_public_path__ + "img/d- (4).fd90a899.png";